export default (enumSrc: object, value: unknown): boolean => {
  return Object.values(enumSrc).includes(value);
};
